module.exports = __webpack_public_path__ + "static/bakery-43b4e1303329c49655ae9760bd6c7de3.jpg";